import { render } from "./InsertButton.html?vue&type=template&id=32977b07&scoped=true&ts=true"
import script from "./InsertButton.ts?vue&type=script&lang=ts"
export * from "./InsertButton.ts?vue&type=script&lang=ts"

import "./InsertButton.scss?vue&type=style&index=0&id=32977b07&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32977b07"]])

export default __exports__